import React from 'react';
import { FavoriteFilledSmall } from '@wix/wix-ui-icons-common/lazy';
import { Text, Box } from '@wix/design-system';
import type { AppReviews } from '@wix/ambassador-appmarket-v1-app-market-client-aggregator/types';
import type { AppBoxSkin } from '../../app-box.types';

export function AppReviewsInfo({
  reviews,
  skin = 'default',
}: {
  reviews: AppReviews;
  skin?: AppBoxSkin;
}) {
  return (
    <Box dataHook="reviews-info" verticalAlign="middle" height="18px" gap="4px">
      <FavoriteFilledSmall
        color={
          reviews.totalCount === 0
            ? 'rgba(22, 45, 61, 0.2)'
            : skin === 'slim'
            ? '#5A5A5A'
            : '#FDB10C'
        }
      />
      <Box gap="5px" verticalAlign="middle">
        <Text data-hook="average-rating" size="tiny" weight="bold">
          {Number(reviews.averageRating).toFixed(1)}
        </Text>
        {skin === 'default' && (
          <Text
            data-hook="total-reviews"
            size="tiny"
            weight="thin"
            secondary
          >{`(${reviews.totalCount})`}</Text>
        )}
      </Box>
    </Box>
  );
}
